import { useQuery } from "@apollo/react-hooks";
import { get } from "lodash";
import React from "react";
import { GET_TIKTOK_PRODUCT_TEMPLATES_ACCESS_LEVEL } from "../../../graphql/queries";
import { arrInvalid } from "../../../helper";

const ProductTemplateAccessLevelCtx = React.createContext(null);

export default function ProductTemplateAccessLevelProvider({
  children,
  templates,
}) {
  const templateIds = getTempalteIds(templates);
  const { data, refetch } = useQuery(
    GET_TIKTOK_PRODUCT_TEMPLATES_ACCESS_LEVEL,
    {
      variables: {
        ids: templateIds,
      },
      skip: arrInvalid(templateIds),
    },
  );

  const bag = React.useMemo(
    () => ({
      ...getUserByTemplate(data),
      refetch,
    }),
    [JSON.stringify(data), refetch],
  );

  return (
    <ProductTemplateAccessLevelCtx.Provider value={bag}>
      {children}
    </ProductTemplateAccessLevelCtx.Provider>
  );
}

function getTempalteIds(templates) {
  const nodes = templates || [];
  const res = [];
  for (let node of nodes) {
    if (!node || !node.id) continue;

    res.push(node.id);
  }

  return Array.from(new Set(res));
}

function getUserByTemplate(data) {
  const nodes = get(data, "getTiktokProductTemplatesAccessLevel") || [];

  const mapUser = {};
  const res = {};
  function getUser(user) {
    const { firstName, lastName } = user || {};
    return [firstName, lastName].filter(Boolean).join(" ");
  }

  for (let node of nodes) {
    if (!node || !node.productTemplateID || !node.user) continue;

    res[node.productTemplateID] = res[node.productTemplateID] || [];
    const user = mapUser[node.userID] || getUser(node.user);

    mapUser[node.userID] = user;
    res[node.productTemplateID].push(user);
  }

  return res;
}

export function useProductTemplateAccessLevel() {
  return React.useContext(ProductTemplateAccessLevelCtx);
}
